import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { cloneDeep, isUndefined, isEqual } from 'lodash';

class ConfirmationModal extends Component {
	constructor() {
		super();

		this.state = {
			show         : false,
			confirmed    : false,
			settings     : {},
			enforceFocus : true,
		};

		this.initialState = cloneDeep(this.state);
	}

	shouldComponentUpdate = (nextProps, { show, settings }) => {
		const lastState = this.state;

		return (
			!isEqual(show, lastState.show)
			|| !isEqual(settings.title, lastState.settings.title)
			|| !isEqual(settings.subTitle, lastState.settings.subTitle)
			|| !isEqual(settings.cancelButton, lastState.settings.cancelButton)
			|| !isEqual(settings.confirmationButton, lastState.settings.confirmationButton)
		);
	}

	openModal = (settings) => {
		this.setState({
			settings,
			show         : true,
			enforceFocus : settings.enforceFocus && true,
		}, () => {
			if (!isUndefined(settings.onOpen)) settings.onOpen();
		});
	}

	onConfirm = (event) => {
		if (event && event.preventDefault) event.preventDefault();

		this.setState({
			show      : false,
			confirmed : true,
		});
	}

	onCancel = (event) => {
		if (event && event.preventDefault) event.preventDefault();

		this.setState({ show : false });
	}

	onExited = () => {
		const {
			confirmed,
			settings : {
				onConfirm,
				onCancel,
			},
		} = this.state;

		if (!isUndefined(onConfirm) && confirmed) onConfirm();
		else if (!isUndefined(onCancel)) onCancel();

		this.resetModal();
	}

	resetModal = () => this.setState(this.initialState)

	render() {
		const {
			show,
			settings : {
				title,
				subTitle,
				cancelButton,
				confirmationButton,
				modalProps,
			},
			enforceFocus,
		} = this.state;

		return (
			<Modal
				{...modalProps /* eslint-disable-line react/jsx-props-no-spreading */}
				enforceFocus={enforceFocus}
				className="confirmation-modal"
				show={show}
				onExited={this.onExited}
				onHide={this.onCancel}
			>
				<Modal.Header>
					<Modal.Title>{ title }</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<p>{ subTitle }</p>
				</Modal.Body>
				<Modal.Footer>
					<Button
						bsStyle="link"
						onClick={this.onCancel}
					>
						{ cancelButton || 'Cancel' }
					</Button>
					<Button
						bsStyle="primary"
						className="btn btn-medium"
						onClick={this.onConfirm}
					>
						{ confirmationButton || 'Confirm' }
					</Button>
				</Modal.Footer>
			</Modal>
		);
	}
}

export default ConfirmationModal;
